var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDepotStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91666 16.25H5.41666V9.58333H14.5833V16.25H17.0833V6.66667L9.99999 3.83333L2.91666 6.66667V16.25ZM1.66666 17.5V5.83333L9.99999 2.5L18.3333 5.83333V17.5H13.3333V10.8333H6.66666V17.5H1.66666ZM7.70832 17.5V16.25H8.95832V17.5H7.70832ZM9.37499 15V13.75H10.625V15H9.37499ZM11.0417 17.5V16.25H12.2917V17.5H11.0417ZM5.41666 9.58333H14.5833H5.41666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDepotStart);
export default __webpack_public_path__ + "static/media/icon-depot-start.d611829daa1947cb7b52db60d356b617.svg";
export { ForwardRef as ReactComponent };